import { memo, useMemo, useRef } from 'react';

import { Markdown } from '../Markdown/Markdown';
import { HighlightedTextProps } from './HighlightedText.types';
import { wrapPlaceholdersWithMark } from './HighlightedText.helpers';
import './HighlightedText.scss';

export const HighlightedText = memo((props: HighlightedTextProps) => {
    const { className, children, useMarkdown = false } = props;

    const ref = useRef<HTMLDivElement | null>(null);
    const content = useMemo(() => wrapPlaceholdersWithMark(children), [children]);

    if (useMarkdown) {
        return (
            <Markdown ref={ref} className={className}>
                {content}
            </Markdown>
        );
    }

    return (
        <span ref={ref} className={className}>
            {content}
        </span>
    );
});
